import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule, TitleCasePipe } from '@angular/common';
import { WarningMessagePopupComponent } from './components/warning-message-popup/warning-message-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { SnackbarMessageComponent } from './components/snackbar-message/snackbar-message.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ProfileImageComponent } from './components/profile-image/profile-image.component';

@NgModule({
	declarations: [WarningMessagePopupComponent, SnackbarMessageComponent, LoaderComponent, ProfileImageComponent],
	imports: [CommonModule, MatIconModule],
	exports: [LoaderComponent, ProfileImageComponent],
	providers: [AsyncPipe, TitleCasePipe],
})
export class SharedModule {}
